(function(){
  function tpl(id){var t=document.getElementById(id);return t?t.content.cloneNode(true):null;}
  function slug(s){return s.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,60);}
  var SKIP=/^(further reading|related|our mission|subscribe|shop |frequently asked|faq)/i;
  function run(){
    var c=document.querySelector('.article-template__content');
    if(!c||c.dataset.mcmA)return; c.dataset.mcmA='1';
    var first=c.firstElementChild; if(first&&first.tagName==='H1')first.remove();

    /* bar under the photo (or under the title when there is no photo) */
    var bar=tpl('mcmA-bar');
    if(bar){
      var w=document.createElement('div');w.className='mcmA-barwrap';w.appendChild(bar);
      var hero=document.querySelector('.article-template__hero-container');
      var anchor=hero||document.querySelector('.article-template header');
      if(anchor&&anchor.parentNode)anchor.parentNode.insertBefore(w,anchor.nextSibling);
    }

    var h2=[].slice.call(c.querySelectorAll(':scope > h2'));
    var real=h2.filter(function(h){return !SKIP.test(h.textContent.trim());});

    /* contents list */
    if(real.length>=3){
      var toc=document.createElement('nav');toc.className='mcmA-toc';toc.setAttribute('aria-label','In this guide');
      var html='<p class="mcmA-label">In this guide</p><ol>';
      real.forEach(function(h){ if(!h.id)h.id=slug(h.textContent); html+='<li><a href="#'+h.id+'">'+h.textContent.trim().replace(/</g,'&lt;')+'</a></li>'; });
      toc.innerHTML=html+'</ol>';
      var ip=c.querySelector(':scope > p');
      if(ip&&ip.compareDocumentPosition(real[0])&Node.DOCUMENT_POSITION_FOLLOWING)ip.after(toc);else c.insertBefore(toc,c.firstChild);
    }

    /* products after the 2nd section */
    var mid=tpl('mcmA-mid');
    if(mid){ if(real[2])c.insertBefore(mid,real[2]); else c.appendChild(mid); }

    /* we buy / find it box near the end */
    var help=tpl('mcmA-help');
    if(help){
      var tail=h2.filter(function(h){return SKIP.test(h.textContent.trim());})[0];
      var spot=tail||(real.length>=5?real[real.length-1]:null);
      if(spot)c.insertBefore(help,spot); else c.appendChild(help);
    }

    /* more products at the end */
    var end=tpl('mcmA-end'); if(end)c.appendChild(end);

    /* phone bar */
    var st=tpl('mcmA-sticky');
    if(st){
      document.body.appendChild(st);
      var bar2=document.querySelector('.mcmA-sticky');
      var foot=document.querySelector('footer, .footer');
      var tick=function(){
        var y=window.scrollY, on=y>500;
        if(foot&&foot.getBoundingClientRect().top<window.innerHeight)on=false;
        document.querySelectorAll('.mcmA-shop').forEach(function(s){var r=s.getBoundingClientRect();if(r.top<window.innerHeight&&r.bottom>0)on=false;});
        bar2.classList.toggle('is-on',on); bar2.setAttribute('aria-hidden',on?'false':'true');
        var a=bar2.querySelector('a'); if(a)a.tabIndex=on?0:-1;
      };
      window.addEventListener('scroll',tick,{passive:true}); tick();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
